import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue';
import SearchStackerView from '../views/SearchStackerView.vue';
import SearchFilterView from '../views/SearchFilterView';
import SearchKeypadView from '../views/SearchKeypadView';


const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/search',
    name: 'search',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ '../views/SearchView.vue'),
    children: [
      // UserHome will be rendered inside User's <router-view>
      // when /users/:username is matched
      { path: 'stacker', component: SearchStackerView },
      { path: 'filter', component: SearchFilterView },
      { path: 'keypad', component: SearchKeypadView },
    ],
  },
  {
    path: '/gallery',
    name: 'gallery',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import( /* webpackChunkName: "about" */ '../views/GalleryView.vue')
  },
  {
    path: '/VirtualTour',
    name: 'VirtualTour',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import( /* webpackChunkName: "about" */ '../views/VirtualTour.vue'),

  },
  {
    path: '/specs',
    name: 'specs',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import( /* webpackChunkName: "about" */ '../views/SpecsView.vue'),

  },{
    path: '/location',
    name: 'location',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import( /* webpackChunkName: "about" */ '../views/LocationView.vue')
  },
  {
    path: '/favourites',
    name: 'favourites',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import( /* webpackChunkName: "about" */ '../views/FavouritesView.vue')
  },{
    path: '/cmslogin',
    name: 'cmslogin',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import( /* webpackChunkName: "about" */ '../views/CmsLogin.vue')
  },{
    path: '/cms',
    name: 'cms',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import( /* webpackChunkName: "about" */ '../views/Cms.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
